export default __webpack_public_path__ + "static/media/face_verfication.8b56f9b2.jpg";